import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "screenmodeoptions"
    }}>{`ScreenModeOptions`}</h1>
    <p>{`Screen mode options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PREVIEW_OFF`}</strong>{` = 1936552047`}</p>
      <p parentName="blockquote">{`Normal view; displays guides and frame edges.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PREVIEW_TO_PAGE`}</strong>{` = 1936552048`}</p>
      <p parentName="blockquote">{`Preview mode; displays the document as it will be printed (hides guides and frame edges).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PREVIEW_TO_BLEED`}</strong>{` = 1936552034`}</p>
      <p parentName="blockquote">{`Preview mode including the bleed area.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PREVIEW_TO_SLUG`}</strong>{` = 1936552051`}</p>
      <p parentName="blockquote">{`Preview mode including the slug area.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PRESENTATION_PREVIEW`}</strong>{` = 1936552046`}</p>
      <p parentName="blockquote">{`Preview mode with editing turned off. Mouse clicks and arrow keys will move to previous or next spread.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      